/**
 * The icons that "More icons" offers, by the name that theme_icon keeps, with a name to show and to
 * search by. Each one must be in public.icon: program_tree leaves out a program whose icon is not.
 */
export const ICON_LIBRARY: readonly { name: string; label: string }[] = [
  { name: "StairsOutlined", label: "Stairs" },
  { name: "SchoolOutlined", label: "Learning" },
  { name: "RocketLaunchOutlined", label: "Launch" },
  { name: "WorkspacePremiumOutlined", label: "Award" },
  { name: "GroupsOutlined", label: "People" },
  { name: "HandshakeOutlined", label: "Handshake" },
  { name: "LightbulbOutlined", label: "Idea" },
  { name: "CelebrationOutlined", label: "Celebration" },
  { name: "SavingsOutlined", label: "Savings" },
  { name: "TrendingUpOutlined", label: "Growth" },
  { name: "FlagOutlined", label: "Goal" },
  { name: "ExploreOutlined", label: "Explore" },
  { name: "WorkOutlined", label: "Work" },
  { name: "BadgeOutlined", label: "Badge" },
  { name: "BusinessCenterOutlined", label: "Briefcase" },
  { name: "ApartmentOutlined", label: "Office" },
  { name: "HomeOutlined", label: "Home" },
  { name: "PublicOutlined", label: "Global" },
  { name: "LanguageOutlined", label: "Language" },
  { name: "CampaignOutlined", label: "Announcement" },
  { name: "ForumOutlined", label: "Conversation" },
  { name: "ChatOutlined", label: "Chat" },
  { name: "MailOutlined", label: "Mail" },
  { name: "NotificationsOutlined", label: "Notifications" },
  { name: "EventOutlined", label: "Calendar" },
  { name: "ScheduleOutlined", label: "Clock" },
  { name: "EmojiEventsOutlined", label: "Trophy" },
  { name: "MilitaryTechOutlined", label: "Medal" },
  { name: "StarOutlined", label: "Star" },
  { name: "FavoriteOutlined", label: "Heart" },
  { name: "VolunteerActivismOutlined", label: "Giving" },
  { name: "Diversity3Outlined", label: "Community" },
  { name: "PersonAddOutlined", label: "New hire" },
  { name: "WavingHandOutlined", label: "Welcome" },
  { name: "PsychologyOutlined", label: "Mindset" },
  { name: "MenuBookOutlined", label: "Book" },
  { name: "AutoStoriesOutlined", label: "Stories" },
  { name: "LocalLibraryOutlined", label: "Library" },
  { name: "ScienceOutlined", label: "Science" },
  { name: "ConstructionOutlined", label: "Construction" },
  { name: "BuildOutlined", label: "Tools" },
  { name: "CodeOutlined", label: "Code" },
  { name: "ComputerOutlined", label: "Computer" },
  { name: "SecurityOutlined", label: "Security" },
  { name: "VerifiedOutlined", label: "Verified" },
  { name: "PolicyOutlined", label: "Policy" },
  { name: "GavelOutlined", label: "Legal" },
  { name: "AccountBalanceOutlined", label: "Finance" },
  { name: "PaymentsOutlined", label: "Payments" },
  { name: "AttachMoneyOutlined", label: "Money" },
  { name: "ReceiptLongOutlined", label: "Receipt" },
  { name: "ShoppingBagOutlined", label: "Shopping" },
  { name: "RestaurantOutlined", label: "Food" },
  { name: "LocalCafeOutlined", label: "Coffee" },
  { name: "SportsSoccerOutlined", label: "Sport" },
  { name: "ParkOutlined", label: "Outdoors" },
  { name: "EnergySavingsLeafOutlined", label: "Sustainability" },
  { name: "TravelExploreOutlined", label: "Travel" },
  { name: "FlightOutlined", label: "Flight" },
  { name: "MapOutlined", label: "Map" },
  { name: "PaletteOutlined", label: "Creative" },
  { name: "PhotoCameraOutlined", label: "Camera" },
  { name: "MicOutlined", label: "Podcast" },
  { name: "MovieOutlined", label: "Video" },
  { name: "MusicNoteOutlined", label: "Music" },
  { name: "ExtensionOutlined", label: "Puzzle" },
  { name: "HubOutlined", label: "Network" },
  { name: "InsightsOutlined", label: "Insights" },
  { name: "BarChartOutlined", label: "Chart" },
  { name: "TrackChangesOutlined", label: "Target" },
  { name: "ChecklistOutlined", label: "Checklist" },
  { name: "TaskAltOutlined", label: "Done" },
  { name: "SupportOutlined", label: "Support" },
  { name: "HelpOutlined", label: "Help" },
  { name: "InfoOutlined", label: "Info" },
  { name: "SubdirectoryArrowRight", label: "Folder" },
];

/** The words of an icon's name: "RocketLaunchOutlined" is "rocket launch". */
const nameWords = (name: string): string =>
  name
    .replace(/Outlined$/, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .toLowerCase();

/** The icons whose label or name has the search in it, or each icon when there is no search. */
export const findIcons = (query: string): readonly { name: string; label: string }[] => {
  const search = query.trim().toLowerCase();
  return search
    ? ICON_LIBRARY.filter(
        ({ name, label }) =>
          label.toLowerCase().includes(search) || nameWords(name).includes(search),
      )
    : ICON_LIBRARY;
};

/** The label of an icon in the library. */
export const iconLabel = (name: string): string | undefined =>
  ICON_LIBRARY.find((icon) => icon.name === name)?.label;
